var Marionette = require('backbone.marionette');
var CommonUtils = require('../../utils/common-utils.js');
var AddendumsTableView = require('./addendums-table-view');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');
var actionsChannel = Radio.channel('actions');

var AddendumsView = Marionette.View.extend({
    template: require('../../templates/documents/addendums.html'),

    regions: {
        addendumsList: '#addendums-list'
    },

    events: {
        'click #add-addendum-comment': 'addAddendumComment'
    },

    ui: {
        addendumCommentText: '#addendum-comment-text'
    },

    initialize: function (options) {
        _.bindAll(this, 'addAddendumComment', 'canUserAddAddendums');
        this.model = options.model;
        this.userPermissions = options.userPermissions || [];
        this.utils = new CommonUtils();
    },

    onRender: function () {
        this.refreshAddendumsTable();
    },

    refreshAddendumsTable: function () {
        var that = this;
        that.showChildView('addendumsList',
            new AddendumsTableView({collectionValues: that.getAddendumsByParent(that.model.get('relations'), that.model.get('id'))}));
    },

    getAddendumsByParent: function (relations, id) {
        return relations.filter(function (item) {
            return item.systemRelationType == 'DOCUMENT_ADDENDUM' && item.parentId == id;
        }).sort(function (itemFirst, itemNext) {
            if (itemFirst.child.createdTime > itemNext.child.createdTime) return 1;
            else if (itemFirst.child.createdTime < itemNext.child.createdTime) return -1;
            else return 0;
        });
    },

    templateContext: function () {
        var that = this;
        return {
            canUserAddAddendums: function() { return that.canUserAddAddendums(); }
        }
    },

    addAddendumComment: function () {
        var comment = this.ui.addendumCommentText.val();
        var that = this;
        that.utils.showSpinner();
        $.ajax({
            type: "POST",
            url: '/api/document/' + this.model.get('id') + '/addendum/comment',
            data: comment,
            contentType: 'text/plain',
            statusCode: {
                200: function (response) {
                    that.utils.hideSpinner();
                    //that.triggerMethod('addendum:created', response);
                    that.model.fetch({
                        success: function() {
                            that.refreshAddendumsTable();
                        }
                    });
                }
            },
            error: function (e) {
                that.utils.hideSpinner();
                if (e.status == 401) {
                    actionsChannel.request("redirect:to:login");
                } else {
                    notificationsChannel.request('show:notification', e.responseJSON);
                }
            }
        });
    },

    canUserAddAddendums: function () {
        var that = this;
        var canEdit = this.utils.userCanDo(this.userPermissions,
            function (permission) {
                return permission.canWriteFor;
            },
            this.model.get('permissions'),
            function (permission) {
                return permission.canWrite;
            }
        );

        var canSign = false;
        (this.model.get('object').reviewers || []).forEach(function (reviewer) {
            if (that.utils.canUserChangeStatus(that.userPermissions, reviewer)) {
                canSign = true;
            }
        });
        return canEdit || canSign;
    }
});

module.exports = AddendumsView;


//////////////////
// WEBPACK FOOTER
// ./app/views/documents/addendums-view.js
// module id = 408
// module chunks = 0